import { type SegmentEventNameValue } from 'const/monitoring/segment'

import { sendCtaClickEvent, sendTrackEvent, TrackEvent } from './service'

interface Analytics {
    trackEvent: (eventName: SegmentEventNameValue, event: TrackEvent) => void
    trackCtaClick: (event: TrackEvent) => void
}

export const useAnalytics = (): Analytics => {
    return {
        trackEvent: sendTrackEvent,
        trackCtaClick: sendCtaClickEvent,
    }
}
